module.exports = __webpack_public_path__ + "static/img/kong.bc3e84bd.png";